import { configureIguazuRPC } from 'iguazu-rpc';

const configureIguazuProcedures = () => {
  configureIguazuRPC({
    getToState: (state) => state.getIn(['modules', 'axp-maps-travelers-cheques-root', 'procedures']),
    // Add any other configuration values you already have (see https://github.com/americanexpress/iguazu-rpc)
  });
};

configureIguazuProcedures();

export default configureIguazuProcedures;
